import { apiWithkey } from "../axios";
import { baseApiURL, getPropostaApi } from "../endpoints";
import useUserStore from "../../storeModules/useUserStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInsuranceStore from "../../storeModules/useInsuranceStore";
import useBotControlStore from "../../storeModules/useBotControlStore";
import findStep from "../../screens/bot/stepModules/findStep";
import { useLocationStore } from "../../storeModules/useLocationStore";
import { createInsuranceContract } from "../requests";
import { tagProposta } from "../../utils/sendTag";
import noConnectionHandler from "../../utils/noConnectionHandler";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { convertPhoneToPayload } from "../../utils/convertPhone";
import getCampanhaDesconto from "../../utils/campanhaDesconto";
import { planoElegivelParaDesconto } from "../../utils/compararDescontos";

dayjs.extend(customParseFormat);

const getProposta = async (couponCode) => {
  const url = `${baseApiURL}${getPropostaApi}`;
  const props = buildPropostaPayload(couponCode);

  setLoadingMessage();

  try {
    const response = await apiWithkey.post(url, props);

    if (!response?.data) {
      handlePropostaError();
    }

    await handlePropostaSuccess(response);
  } catch (error) {
    handlePropostaError(error);
  } finally {
    removeLoadingMessage();
  }
};

// Função auxiliar para construir o payload da proposta
const buildPropostaPayload = (couponCode) => {
  const locationData = useLocationStore.getState().location;
  const contratoData = useUserStore.getState().contrato;
  const basicData = useUserStore.getState().basic;
  const { LeadID } = useUserStore.getState().lead;
  const { planoID, planoMeses, bemID, planoTaxaAdmTotal } =
    useConsorcioStore.getState().selectedPlano;
  const { isInsuranceHired, idCotacao, valorPremio } =
    useInsuranceStore.getState();
  const { empresaId } = useInitialConfigStore.getState();

  const nascimentoFundacaoProposta = dayjs(
    contratoData.nascimentoFundacao,
    "DD/MM/YYYY",
  ).toDate();

  const campanha = getCampanhaDesconto();
  const campanhaAplicavel = planoElegivelParaDesconto(
    planoTaxaAdmTotal,
    campanha,
  );
  const finalCouponCode =
    couponCode || (campanhaAplicavel ? campanha.cupom : null);

  return {
    bairro: contratoData.bairro,
    bemID: bemID,
    cep: contratoData.cep,
    cidade: contratoData.cidade,
    complemento: "",
    cpfCnpj: contratoData.cpfCnpj,
    email: basicData.email,
    empresaId,
    estado: contratoData.estado,
    leadId: LeadID.toString(),
    logradouro: contratoData.logradouro,
    nascimentoFundacao: nascimentoFundacaoProposta,
    nome: contratoData.nomeRazao,
    nomeRazao: contratoData.nomeRazao,
    numero: "0",
    planoID: planoID,
    planoMeses: planoMeses,
    rendaFaturamento: basicData.rendaMensal.toString(),
    rendaMensal: basicData.rendaMensal.toString(),
    telefone: convertPhoneToPayload(basicData.telefone),
    telefoneCelular: convertPhoneToPayload(basicData.telefone),
    autoriza: true,
    aceiteRegulamento: contratoData.aceiteRegulamento,
    tipoPessoa: contratoData.tipoPessoa,
    cupomCodigo: finalCouponCode ? String(finalCouponCode) : null,
    geoLocation: buildGeoLocationData(locationData),
    ...(isInsuranceHired && {
      seguro: {
        idCotacao: isInsuranceHired ? idCotacao : null,
        valorPremio: isInsuranceHired ? valorPremio : null,
      },
    }),
  };
};

// Função auxiliar para construir dados de geolocalização
const buildGeoLocationData = (locationData) => ({
  geoId: locationData?.geoId || null,
  cidadeGeo: locationData?.city || null,
  estadoGeo: locationData?.region || null,
  estadoGeoId: locationData?.regionId || null,
  paisGeo: locationData?.country || null,
  latitudeGeo: locationData?.latitude || null,
  longitudeGeo: locationData?.longitude || null,
});

// Função auxiliar para lidar com sucesso da proposta
const handlePropostaSuccess = async (response) => {
  const consorcioData = useConsorcioStore.getState();
  const { data } = response.data;
  const { isInsuranceHired } = useInsuranceStore.getState();

  tagProposta(data.propostaID, data.contrato);

  if (data?.propostaID) {
    useConsorcioStore.setState({
      ...consorcioData,
      fetchedProposta: data,
    });
    try {
      localStorage.setItem("mycon_fetched_proposta", JSON.stringify(data));
    } catch (_) {}
  }

  if (isInsuranceHired) {
    await noConnectionHandler().then(() => {
      createInsuranceContract(data.contrato);
    });
  }

  useBotControlStore.setState({
    currentStep: findStep("aguarda_proposta").index,
  });
};

// Função auxiliar para lidar com erros da proposta
const handlePropostaError = (error) => {
  const isCepError = error?.response?.data?.errors?.includes(
    "O CEP informado, não é válido!",
  );

  if (isCepError) {
    useBotControlStore.setState({
      currentStep: findStep("cep_nao_encontrado").index,
    });
    useUserStore.setState({
      cepErrorAt: "proposta",
    });
    return;
  }

  useBotControlStore.setState({
    currentStep: findStep("erro_proposta").index,
  });
};

export default getProposta;
